import { takeLatest } from 'redux-saga/effects';
import { getPaginatedListSaga } from '../../../store/structures';
import { types, actions } from './duck';
import { getApplyCouponList } from '../../coupons/api';

export default function* saga() {
  yield takeLatest(
    types.GET_APPLY_COUPON_LIST,
    getPaginatedListSaga(actions, getApplyCouponList),
  );
}
